import React, { useEffect, useMemo, useState } from 'react';
import CustomDialog from '../../../components/CustomDialog';
import SaveLoading from '../../../components/SaveLoading';
import { FaSave } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

const sampleSnapshotSummary = [
  {
    "snapshot_summary_id": 1,
    "selected_date": "2024-06-15",
    "created_at": "2024-06-15T14:30:00Z",
    "details": [
      [
        {
          "base":{ "eventTime": "2025-12-11T15:30:00", "leagueName": "South East Asian Games Women", "homeTeam": "Vietnam (W)", "awayTeam": "Myanmar (W)", "homeGoal": 2, "awayGoal": 0, "status": 1, "finished": false, "canceled": false, "eventId": 186095338 },
          "reference": null,
          "createdAt": "2025-12-11 15:55:47",
          "source": "Status Inconsistency"
        },
        {
          "base":{ "eventTime": "2025-12-11T15:30:00", "leagueName": "South East Asian Games Women", "homeTeam": "Vietnam (W)", "awayTeam": "Myanmar (W)", "homeGoal": 2, "awayGoal": 0, "status": 1, "finished": false, "canceled": false, "eventId": 186095338 },
          "reference": null,
          "createdAt": "2025-12-11 16:55:47",
          "source": "Status Inconsistency"
        },
         {
          "base":{ "eventTime": "2025-12-11T15:30:00", "leagueName": "South East Asian Games Women", "homeTeam": "Vietnam (W)", "awayTeam": "Myanmar (W)", "homeGoal": 2, "awayGoal": 0, "status": 1, "finished": false, "canceled": false, "eventId": 186095338 },
          "reference": null,
          "createdAt": "2025-12-11 17:55:47",
          "source": "Status Inconsistency"
        },
        {
          "base":{ "eventTime": "2025-12-11T15:30:00", "leagueName": "South East Asian Games Women", "homeTeam": "Vietnam (W)", "awayTeam": "Myanmar (W)", "homeGoal": 2, "awayGoal": 0, "status": 1, "finished": false, "canceled": false, "eventId": 186095338 },
          "reference": null,
          "createdAt": "2025-12-11 18:55:47",
          "source": "Status Inconsistency"
        }
      ]
    ],
    "sent_msg": true,
    "status": "Waiting",
    "approved_at": "2024-06-15T15:00:00Z",
    "approved_by": "admin",
    "event_id": 12345,
  }
]

const getGoalString = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
};

const coerceFormattedDetails = (summary) => {
  if (!summary) {
    return [];
  }

  if (Array.isArray(summary.formattedDetails)) {
    return summary.formattedDetails;
  }

  const { details } = summary;
  if (Array.isArray(details)) {
    return details;
  }

  if (typeof details === 'string') {
    try {
      const parsed = JSON.parse(details);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('Failed to parse snapshot details', error);
    }
  }

  return [];
};

const flattenDetails = (rawDetails) => {
  if (!Array.isArray(rawDetails)) {
    return [];
  }

  return rawDetails.reduce((acc, item) => {
    if (Array.isArray(item)) {
      acc.push(...flattenDetails(item));
    } else if (item && typeof item === 'object') {
      acc.push(item);
    }
    return acc;
  }, []);
};

const formatScore = (home, away) => {
  if (home === null || home === undefined || away === null || away === undefined) {
    return '-';
  }
  return `${home} - ${away}`;
};

const formatDateTime = (value) => {
  if (!value) {
    return '-';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString();
};

const buildTeamMeta = (entry = {}) => {
  const homeTeam = entry?.homeTeam ?? entry?.home_team ?? entry?.home ?? '-';
  const awayTeam = entry?.awayTeam ?? entry?.away_team ?? entry?.away ?? '-';
  const eventTime = entry?.eventTime ?? entry?.event_time ?? entry?.kickoff ?? null;
  const leagueName = entry?.leagueName ?? entry?.league ?? entry?.league_name ?? 'Unknown League';
  const status = entry?.status ?? entry?.state ?? entry?.matchStatus ?? null;

  return {
    eventId: entry?.eventId ?? entry?.event_id ?? entry?.id ?? null,
    leagueName,
    matchup: `${homeTeam} vs ${awayTeam}`,
    score: formatScore(
      entry?.homeGoal ?? entry?.home_goal ?? entry?.homeScore ?? entry?.home_score ?? null,
      entry?.awayGoal ?? entry?.away_goal ?? entry?.awayScore ?? entry?.away_score ?? null,
    ),
    status,
    flags: {
      finished: Boolean(entry?.finished ?? entry?.isFinished),
      canceled: Boolean(entry?.canceled ?? entry?.isCanceled),
    },
    eventTime
  };
};

const SnapshotTeamCard = ({ title, base, reference, emptyText, createdAt }) => {
  console.log('SnapshotTeamCard base:', base);
  console.log('SnapshotTeamCard reference:', reference);
  if (!base) {
    return (
      <div className='flex min-h-[140px] flex-col items-center justify-center rounded-2xl border border-dashed border-customBorder/50 bg-customSlate/40 px-4 py-3 text-sm text-customSecondaryText dark:border-customSurfaceMuted dark:bg-customSurface'>
        <p className='text-center text-xs'>
          {emptyText ?? `No ${title.toLowerCase()} data available.`}
        </p>
      </div>
    );
  }

  const flagBadges = [];
  if (base.flags?.finished) {
    flagBadges.push('Finished');
  }
  if (base.flags?.canceled) {
    flagBadges.push('Canceled');
  }

  return (
    <div className='rounded-lg w-full border border-customBorder/60 bg-white p-1 shadow-sm dark:border-customSurfaceMuted dark:bg-customSurface'>
      <p className={`text-xs font-semibold text-customInk dark:text-customHeading`}>
        <span className='text-customAccent dark:text-customRiver'>Sport909</span> : Status is {RAPID_STATUS_MAP[base.status] === undefined ? "Unknown" : RAPID_STATUS_MAP[base.status]} and Result is {base.status === 3 ? base.score : 'N/A'} 
      </p>
      {
        reference ? 
          <p className={`text-xs font-semibold text-customInk dark:text-customHeading`}>
            {
              reference.flags.finished && reference.flags.canceled ?
                <>
                  <span className='text-customDarkGreen dark:text-customDarkGreen'>555Mix</span> : <span>status is Postponed and result is N/A</span>
                </>
                : <>
                  <span className='text-customDarkGreen dark:text-customDarkGreen'>555Mix</span> : <span>status is {reference.status} and result is {reference.score}</span>
                </>
            }
          </p> : 
      <p className={`text-xs font-semibold text-customDarkGreen dark:text-customDarkGreen`}> No reference data available.</p>
      }
    
      <p className='text-[11px] text-customSecondaryText dark:text-customMuted'>
        Created: {formatDateTime(createdAt)}
      </p>
      {/* {flagBadges.length > 0 ? (
        <div className='mt-2 flex flex-wrap gap-2'>
          {flagBadges.map((flag) => (
            <span
              key={flag}
              className='rounded-full bg-customSky px-2 py-[2px] text-[11px] font-semibold text-customSecondaryText dark:bg-customSurfaceMuted dark:text-customHeading'
            >
              {flag}
            </span>
          ))}
        </div>
      ) : null} */}
    </div>
  );
};

const SnapshotModal = ({
  selectedSnapshot,
  isMobile,
  open,
  setOpen,
  saveLoading,
  onSave,
}) => {
  const { league: leagueName, kickoff, fixtures, snapshots: snapshotSummary } = selectedSnapshot || {};


  const selectedSummary = snapshotSummary?.[0] ?? null;
  //console.log('Selected Summary:', selectedSummary);

  const [homeGoal, setHomeGoal] = useState('');
  const [awayGoal, setAwayGoal] = useState('');
  const [isPostponed, setIsPostponed] = useState(false);

  useEffect(() => {
    if (!selectedSummary || !open) {
      setHomeGoal('');
      setAwayGoal('');
      setIsPostponed(false);
      return;
    }

    setHomeGoal(
      getGoalString(
        selectedSummary?.homeGoal ??
          selectedSummary?.home_goal ??
          selectedSummary?.baseHomeGoal ??
          selectedSummary?.base_home_goal,
      ),
    );

    setAwayGoal(
      getGoalString(
        selectedSummary?.awayGoal ??
          selectedSummary?.away_goal ??
          selectedSummary?.baseAwayGoal ??
          selectedSummary?.base_away_goal,
      ),
    );

    setIsPostponed(
      Boolean(
        selectedSummary?.isPostponed ??
          selectedSummary?.is_postponed ??
          selectedSummary?.postponed ??
          (selectedSummary?.status ?? '')
            .toString()
            .toLowerCase()
            .includes('post'),
      ),
    );

  }, [selectedSummary, open]);

  const formattedDetails = useMemo(() => {
    const rawDetails = coerceFormattedDetails(selectedSummary);
    const normalizedDetails = flattenDetails(rawDetails);

    return normalizedDetails.map((detail, index) => {
      const baseMeta = detail?.base ? buildTeamMeta(detail.base) : null;
      const referenceMeta = detail?.reference ? buildTeamMeta(detail.reference) : null;
      return {
        id: detail?.id ?? detail?.snapshotDetailId ?? `detail-${index}`,
        source: detail?.source ?? detail?.reason ?? 'Snapshot',
        createdAt: detail?.createdAt ?? detail?.created_at ?? detail?.timestamp ?? null,
        base: baseMeta,
        reference: detail?.reference ? referenceMeta : null,
      };
    });
  },[selectedSummary]);

  const parseGoalValue = (value) => {
    if (value === '') {
      return null;
    }
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const handleGoalChange = (setter) => (event) => {
    const nextValue = event.target.value;
    if (/^\d*$/.test(nextValue)) {
      setter(nextValue);
    }
  };

  const matchup = fixtures?.[0]?.matchup ?? 'Unknown Matchup';

  const status = selectedSummary?.status ?? null;
  const approved_at = selectedSummary?.approved_at?.value ?? "N/A";
  const approved_by = selectedSummary?.approved_by ?? "N/A";

  const baseEventId =
    selectedSummary?.event_id ??
    selectedSummary?.baseEventId ??
    selectedSummary?.base_event_id ??
    null;

  const buildPayload = () => {
    if (!selectedSummary) {
      return null;
    }

    return {
      snapshotId: selectedSummary?.snapshot_summary_id ?? null,
      baseEventId: baseEventId,
      homeGoal: parseGoalValue(homeGoal),
      awayGoal: parseGoalValue(awayGoal),
      isPostponed,
      approved_by: 'ResultHubUser',
    };
  };

  const handleSave = () => {
    const payload = buildPayload();
    if (!payload) {
      return;
    }

    console.log('Snapshot payload ready:', payload);
    if (typeof onSave === 'function') {
      onSave(payload);
    }
  };

  const disableSave = !selectedSummary || homeGoal === '' || awayGoal === '' || saveLoading;

  return (
    <CustomDialog
      open={open}
      isMobile={isMobile}
      width={isMobile ? 360 : 640}
      padding={isMobile ? 3 : 4}
    >
      {saveLoading && <SaveLoading loading={saveLoading} />}
      <div className='space-y-4 text-customPrimaryText dark:text-customHeading'>
        <div className='flex items-start justify-between gap-4'>
          <div>
            <p className='text-[11px] uppercase tracking-wide text-customSecondaryText dark:text-customMuted'>
              Snapshot Review
            </p>
            <p className='text-lg font-semibold text-customInk dark:text-customHeading'>
              {matchup} <span className={`${status?.toLowerCase() === 'waiting' ? 'text-customFontGold' : 'text-teal-600'}`}>{status}</span>
            </p>
            <div className='text-xs text-customSecondaryText dark:text-customMuted'>
              <span>{leagueName}</span>
              <span className='mx-1'>•</span>
              <span>{kickoff}</span>
              {baseEventId ? (
                <>
                  <span className='mx-1'>•</span>
                  <span>#{baseEventId}</span>
                </>
              ) : null}
            </div>
            <p className='text-xs text-customInk dark:text-customMuted'>Approved at : {formatDateTime(approved_at)}</p>
            <p className='text-xs text-customInk dark:text-customMuted'>Approved by : {approved_by}</p>
          </div>
          <button
            type='button'
            className='flex items-center gap-1 rounded-full border border-customBorder px-2 py-[4px] text-xs text-customSecondaryText hover:text-customInk dark:border-customSurfaceMuted dark:text-customMuted dark:hover:text-customHeading'
            onClick={() => setOpen(false)}
          >
            <ImCross className='text-[10px]' />
            Close
          </button>
        </div>

        {selectedSummary ? (
          <>
            <div
              className='rounded-lg border border-customBorder/70 bg-customSlate/60 p-1 shadow-sm dark:border-customSurfaceMuted dark:bg-customSurface'
            >
              <div className='flex max-h-52 flex-col gap-2 overflow-y-auto pr-1 text-sm font-semibold text-customInk dark:text-customHeading'>
                {formattedDetails.length > 0 ? (
                  formattedDetails.map((detail, i) => (
                    <div className='mb-1' key={i}>
                      <SnapshotTeamCard
                        title='Base Event'
                        base={detail.base}
                        reference={detail.reference}
                        createdAt={detail.createdAt}

                      />
                    </div>
                  ))
                ) : (
                  <div className='rounded-xl border border-dashed border-customBorder/60 bg-customSlate px-3 py-3 text-sm text-customSecondaryText dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customMuted'>
                    No formatted details provided for this snapshot.
                  </div>
                )}
              </div>
            </div>

            <div className='rounded-lg border border-customBorder bg-customSky p-2 shadow-sm dark:border-customSurfaceMuted dark:bg-customSurface'>
              <p className='mb-3 text-sm font-semibold text-customInk dark:text-customHeading'>
                Update score
              </p>
              <div className='grid grid-cols-1 gap-3 md:grid-cols-2'>
                <label className='flex flex-col text-xs font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted'>
                  Home Goal
                  <input
                    type='text'
                    inputMode='numeric'
                    value={homeGoal}
                    onChange={handleGoalChange(setHomeGoal)}
                    placeholder='e.g. 2'
                    className='mt-1 rounded-lg border border-customBorder/70 bg-white px-3 py-2 text-sm font-medium text-customPrimaryText outline-none transition focus:border-customAccent focus:ring-2 focus:ring-customAccent/30 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted dark:text-customHeading'
                  />
                </label>
                <label className='flex flex-col text-xs font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted'>
                  Away Goal
                  <input
                    type='text'
                    inputMode='numeric'
                    value={awayGoal}
                    onChange={handleGoalChange(setAwayGoal)}
                    placeholder='e.g. 1'
                    className='mt-1 rounded-lg border border-customBorder/70 bg-white px-3 py-2 text-sm font-medium text-customPrimaryText outline-none transition focus:border-customAccent focus:ring-2 focus:ring-customAccent/30 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted dark:text-customHeading'
                  />
                </label>
              </div>
              <label className='mt-3 flex items-center gap-2 text-sm font-medium text-customPrimaryText dark:text-customHeading'>
                <input
                  type='checkbox'
                  checked={isPostponed}
                  onChange={(event) => setIsPostponed(event.target.checked)}
                  className='h-4 w-4 rounded border-customBorder text-customAccent focus:ring-customAccent'
                />
                Mark event as postponed
              </label>
            </div>
          </>
        ) : (
          <div className='rounded-xl border border-dashed border-customBorder/60 bg-customSlate px-3 py-5 text-sm text-customSecondaryText dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customMuted'>
            Choose a snapshot to see its summary and update scores.
          </div>
        )}

        <div className='flex items-center justify-end gap-2'>
          <button
            type='button'
            className='rounded-lg border border-customBorder px-4 py-2 text-sm font-medium text-customSecondaryText transition hover:text-customInk dark:border-customSurfaceMuted dark:text-customMuted dark:hover:text-customHeading'
            onClick={() => setOpen(false)}
          >
            Cancel
          </button>
          <button
            type='button'
            className='flex items-center gap-2 rounded-lg bg-customAccentBlue dark:bg-customAccent dark:disabled:bg-customAccent/40 px-4 py-2 text-sm font-semibold text-white transition hover:bg-customAccentBlue/90 disabled:cursor-not-allowed disabled:bg-customAccentBlue/40'
            disabled={disableSave}
            onClick={handleSave}
          >
            <FaSave />
            Save Snapshot
          </button>
        </div>
      </div>
    </CustomDialog>
  );
};

export default SnapshotModal;

const RAPID_STATUS_MAP = {
  0: 'Not Started',
  1: 'InPlay',
  2: 'TO BE FIXED', 
  3: 'Ended',
  4: 'Postponed',
  5: 'Cancelled',
  6: 'Walkover',
  7: 'Interrupted',
  8: 'Abandoned',
  9:  'Retired',
  10: 'Suspended',
  11: 'Decided by FA',
  12 : 'Disqualified',
  13 : 'Removed'
}
